module.exports = __webpack_public_path__ + "static/media/adminLogo.e0b35075.jpg";